/* eslint indent: "off" */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import Layout from '../Layout/index';
import Register from '../Register/index';

// Login
import Landing from '../Landing/LogIn';
// import LoginCheck from '../Landing/loginCheck';

// Dashboard
import Home from '../Dashboard/index';

// Profile
import ChangePassword from '../Account/ChangePassword/index';
import ChangeRecoverPassword from '../Account/ChangeRecoverPassword/index';
import ForgotPassword from '../Account/ForgotPassword/index';
import LoginChangePassword from '../Account/LoginChangePassword/index';
import Profile from '../Account/Profile';

import EmailTemplate from '../Cruds/EmailTemplates';
import Roles from '../Cruds/Roles';
import Activities from '../Cruds/Activities'
import EmailStatus from '../Cruds/EmailStatus/index';
// Tables
import Employees from '../Cruds/Employees/index';
import Hospitalemployees from '../Cruds/Hospitalemployees/index';
import Facilityemployees from '../Cruds/Facilityemployees/index';
import Providerss from '../Cruds/Providerss/index';
import Facilitiess from '../Cruds/Facilitiess/index';
import Patientss from '../Cruds/Patientss/index';
import Orderss from '../Cruds/Orderss/index';
import Appointmentss from '../Cruds/Appointmentss/index';
import Slotss from '../Cruds/Slotss/index';

import Settings from '../Cruds/Settings/index'
import AdminSettings from '../Settings/index'
import Uploads from '../Cruds/Uploads/index';
// 404 page not found 
import ErrorNotFound from '../Account/404/index';
import config from '../../config/config';

const Tables = () => {
  let roles = localStorage.rolePermissions
    ? JSON.parse(localStorage.rolePermissions)
    : false;
  if (roles) {
    return (<Switch>
      <Route path="/employees"
           component={
              roles['Employee'] &&
                (roles['Employee'] === "Edit" || roles['Employee'] === "View")
                ? Employees 
                  : ErrorNotFound
                } />

          <Route
          path="/create_employees"
          render={
            roles['Employee'] &&
              (roles['Employee'] === "Edit" )
              ?  props => <Employees {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/edit_employees/:id"
          render={
            roles['Employee'] &&
              (roles['Employee'] === "Edit" )
              ?  props => <Employees {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/view_employees/:id"
          render={
            roles['Employee'] &&
              (roles['Employee'] === "Edit" || roles['Employee'] === "View")
              ?  props => <Employees {...props} />  
              : ErrorNotFound
          }
        />
<Route path="/provideremployees"
           component={
              roles['Provideremployee'] &&
                (roles['Provideremployee'] === "Edit" || roles['Provideremployee'] === "View")
                ? Hospitalemployees 
                  : ErrorNotFound
                } />

          <Route
          path="/create_provideremployees"
          render={
            roles['Provideremployee'] &&
              (roles['Provideremployee'] === "Edit" )
              ?  props => <Hospitalemployees {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/edit_provideremployees/:id"
          render={
            roles['Provideremployee'] &&
              (roles['Provideremployee'] === "Edit" )
              ?  props => <Hospitalemployees {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/view_provideremployees/:id"
          render={
            roles['Provideremployee'] &&
              (roles['Provideremployee'] === "Edit" || roles['Provideremployee'] === "View")
              ?  props => <Hospitalemployees {...props} />  
              : ErrorNotFound
          }
        />
<Route path="/facilityemployees"
           component={
              roles['Facilityemployee'] &&
                (roles['Facilityemployee'] === "Edit" || roles['Facilityemployee'] === "View")
                ? Facilityemployees 
                  : ErrorNotFound
                } />

          <Route
          path="/create_facilityemployees"
          render={
            roles['Facilityemployee'] &&
              (roles['Facilityemployee'] === "Edit" )
              ?  props => <Facilityemployees {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/edit_facilityemployees/:id"
          render={
            roles['Facilityemployee'] &&
              (roles['Facilityemployee'] === "Edit" )
              ?  props => <Facilityemployees {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/view_facilityemployees/:id"
          render={
            roles['Facilityemployee'] &&
              (roles['Facilityemployee'] === "Edit" || roles['Facilityemployee'] === "View")
              ?  props => <Facilityemployees {...props} />  
              : ErrorNotFound
          }
        />
<Route path="/providerss"
           component={
              roles['Providers'] &&
                (roles['Providers'] === "Edit" || roles['Providers'] === "View")
                ? Providerss 
                  : ErrorNotFound
                } />

          <Route
          path="/create_providerss"
          render={
            roles['Providers'] &&
              (roles['Providers'] === "Edit" )
              ?  props => <Providerss {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/edit_providerss/:id"
          render={
            roles['Providers'] &&
              (roles['Providers'] === "Edit" )
              ?  props => <Providerss {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/view_providerss/:id"
          render={
            roles['Providers'] &&
              (roles['Providers'] === "Edit" || roles['Providers'] === "View")
              ?  props => <Providerss {...props} />  
              : ErrorNotFound
          }
        />
<Route path="/facilitiess"
           component={
              roles['Facilities'] &&
                (roles['Facilities'] === "Edit" || roles['Facilities'] === "View")
                ? Facilitiess 
                  : ErrorNotFound
                } />

          <Route
          path="/create_facilitiess"
          render={
            roles['Facilities'] &&
              (roles['Facilities'] === "Edit" )
              ?  props => <Facilitiess {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/edit_facilitiess/:id"
          render={
            roles['Facilities'] &&
              (roles['Facilities'] === "Edit" )
              ?  props => <Facilitiess {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/view_facilitiess/:id"
          render={
            roles['Facilities'] &&
              (roles['Facilities'] === "Edit" || roles['Facilities'] === "View")
              ?  props => <Facilitiess {...props} />  
              : ErrorNotFound
          }
        />
<Route path="/patientss"
           component={
              roles['Patients'] &&
                (roles['Patients'] === "Edit" || roles['Patients'] === "View")
                ? Patientss 
                  : ErrorNotFound
                } />

          <Route
          path="/create_patientss"
          render={
            roles['Patients'] &&
              (roles['Patients'] === "Edit" )
              ?  props => <Patientss {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/edit_patientss/:id"
          render={
            roles['Patients'] &&
              (roles['Patients'] === "Edit" )
              ?  props => <Patientss {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/view_patientss/:id"
          render={
            roles['Patients'] &&
              (roles['Patients'] === "Edit" || roles['Patients'] === "View")
              ?  props => <Patientss {...props} />  
              : ErrorNotFound
          }
        />
<Route path="/orderss"
           component={
              roles['Orders'] &&
                (roles['Orders'] === "Edit" || roles['Orders'] === "View")
                ? Orderss 
                  : ErrorNotFound
                } />

          <Route
          path="/create_orderss"
          render={
            roles['Orders'] &&
              (roles['Orders'] === "Edit" )
              ?  props => <Orderss {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/edit_orderss/:id"
          render={
            roles['Orders'] &&
              (roles['Orders'] === "Edit" )
              ?  props => <Orderss {...props} />  
              : ErrorNotFound
          }
        />

          <Route
          path="/view_orderss/:id"
          render={
            roles['Orders'] &&
              (roles['Orders'] === "Edit" || roles['Orders'] === "View")
              ?  props => <Orderss {...props} />  
              : ErrorNotFound
          }
        />

      {/* <Route path="/settings" component={Settings} /> */}
      {/* <Route path="/adminSettings" component={AdminSettings} /> */}
      <Route
        path="/adminSettings"
        render={
          config.displaySettings
            ? props => <AdminSettings />
            : ErrorNotFound
        }
      />
      <Route
        path="/uploads"
        component={
          roles["Upload History"] &&
            (roles["Upload History"] === "Edit" || roles["Upload History"] === "View")
            ? Uploads
            : ErrorNotFound
        }
      />

      <Route
        path="/activities"
        component={
          roles["Activities"] &&
            (roles["Activities"] === "Edit" || roles["Activities"] === "View")
            ? Activities
            : ErrorNotFound
        }
      />
       <Route
        path="/view_activities/:id"
        component={
          roles["Activities"] &&
            (roles["Activities"] === "Edit" || roles["Activities"] === "View")
            ?  props => <Activities {...props} />
            : ErrorNotFound
        }
      />

      <Route
        path="/roles"
        component={
          roles["Roles"] &&
            (roles["Roles"] === "Edit" || roles["Roles"] === "View")
            ? Roles
            : ErrorNotFound
        }
      />
        <Route
        path="/create_roles"
        render={
          roles["Roles"] &&
            (roles["Roles"] === "Edit" )
            ?  props => <Roles {...props} />  
            : ErrorNotFound
        }
      />
        <Route
        path="/edit_roles/:id"
        render={
          roles["Roles"] &&
            (roles["Roles"] === "Edit" )
            ?  props => <Roles {...props} />  
            : ErrorNotFound
        }
      />
        <Route
        path="/view_roles/:id"
        render={
          roles["Roles"] &&
            (roles["Roles"] === "Edit" || roles["Roles"] === "View")
            ?  props => <Roles {...props} />  
            : ErrorNotFound
        }
      />
      <Route
        path="/emailstatus"
        component={
          roles["Email Status"] &&
            (roles["Email Status"] === "Edit" || roles["Email Status"] === "View")
            ? EmailStatus
            : ErrorNotFound
        }
      />

      <Route
        path="/templates"
        component={
          roles["Email Templates"] &&
            (roles["Email Templates"] === "Edit" || roles["Email Templates"] === "View")
            ? EmailTemplate
            : ErrorNotFound
        }
      />
        <Route
        path="/create_templates"
        render={
          roles["Email Templates"] &&
            (roles["Email Templates"] === "Edit" )
            ?  props => <EmailTemplate {...props} />  
            : ErrorNotFound
        }
      />
        <Route
        path="/edit_templates/:id"
        render={
          roles["Email Templates"] &&
            (roles["Email Templates"] === "Edit" )
            ?  props => <EmailTemplate {...props} />  
            : ErrorNotFound
        }
      />
        <Route
        path="/view_templates/:id"
        render={
          roles["Email Templates"] &&
            (roles["Email Templates"] === "Edit" || roles["Email Templates"] === "View")
            ?  props => <EmailTemplate {...props} />  
            : ErrorNotFound
        }
      />
      <Route path="/appointmentss"
        component={
          roles['Appointments'] &&
            (roles['Appointments'] === "Edit" || roles['Appointments'] === "View")
            ? Appointmentss
            : ErrorNotFound
        } />

      <Route
        path="/create_appointmentss"
        render={
          roles['Appointments'] &&
            (roles['Appointments'] === "Edit")
            ? props => <Appointmentss {...props} />
            : ErrorNotFound
        }
      />

      <Route
        path="/edit_appointmentss/:id"
        render={
          roles['Appointments'] &&
            (roles['Appointments'] === "Edit")
            ? props => <Appointmentss {...props} />
            : ErrorNotFound
        }
      />

      <Route
        path="/view_appointmentss/:id"
        render={
          roles['Appointments'] &&
            (roles['Appointments'] === "Edit" || roles['Appointments'] === "View")
            ? props => <Appointmentss {...props} />
            : ErrorNotFound
        }
      />
      <Route path="/slotss"
        component={
          roles['Slots'] &&
            (roles['Slots'] === "Edit" || roles['Slots'] === "View")
            ? Slotss
            : ErrorNotFound
        } />

      <Route
        path="/create_slotss"
        render={
          roles['Slots'] &&
            (roles['Slots'] === "Edit")
            ? props => <Slotss {...props} />
            : ErrorNotFound
        }
      />

      <Route
        path="/edit_slotss/:id"
        render={
          roles['Slots'] &&
            (roles['Slots'] === "Edit")
            ? props => <Slotss {...props} />
            : ErrorNotFound
        }
      />

      <Route
        path="/view_slotss/:id"
        render={
          roles['Slots'] &&
            (roles['Slots'] === "Edit" || roles['Slots'] === "View")
            ? props => <Slotss {...props} />
            : ErrorNotFound
        }
        />
      {/* <Route path="/uploads" component={Uploads} />
    <Route path="/activities" component={Activities} />
    <Route path="/roles" component={Roles} />
    <Route path="/templates" component={EmailTemplate} /> */}
    </Switch >
    )
  }
}

const Account = () => (
  <Switch>
    <Route path="/changepassword" component={ChangePassword} />
    <Route path="/profile" component={Profile} />
  </Switch>
);

const wrappedRoutes = () => {
  let loginCredentials = localStorage.loginCredentials ? JSON.parse(localStorage.loginCredentials) : false;
  if (loginCredentials) {
    return <div>
      <Layout />
      <div className="container__wrap">
        <Route path="/" component={Account} />
        <Route path="/" component={Tables} />
        <Route path="/dashBoard" component={Home} />
      </div>
    </div>
  }
  else {
    return <ErrorNotFound />
  }
}

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route path="/changeRecoverPassword/:enEmail" render={(props) => <ChangeRecoverPassword
          {...props} />} />
        <Route path="/loginChangePassword" component={LoginChangePassword} />
        <Route exact path="/" component={Landing} />
        <Route path="/log_in" component={Landing} />
        <Route path="/logout" component={Landing} />
        <Route path="/forgot_password" component={ForgotPassword} />
        <Route path="/register" component={Register} />

        <Route path="/" component={wrappedRoutes} />
        <Route component={ErrorNotFound} />

      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
